import * as Schema from 'nutshell-core/schema';

import type {CriteriaField} from './user-assignments-types';

// @ts-expect-error
const trackJs = window.trackJs;
/*
 * This pulls out the first element from the `relationships` of the field's schema.
 * The fields we are currently using only have one relationship, so this should
 * be fine.  The relationship can be treated as the collection name for this field.
 */
export function getCollectionNameFromFieldName(
    field: string | null | undefined,
    schema: Schema.Properties
): CriteriaField | null | undefined {
    if (!field) return null;

    const fieldSchema = schema[field];
    if (!fieldSchema) {
        if (trackJs) {
            trackJs.track('getCollectionNameFromFieldName: Could not find schema for field.');
        }

        return null;
    }

    if (fieldSchema.type !== 'relationship') {
        if (trackJs) {
            trackJs.track(
                'getCollectionNameFromFieldName: Tried to get collection name from a non-relationship field'
            );
        }

        return null;
    }

    const relationships = fieldSchema.relationships;
    if (!relationships || !relationships.length) {
        if (trackJs) {
            trackJs.track(
                'getCollectionNameFromFieldName: Tried to get collection name from field without a relationship'
            );
        }

        return null;
    }

    // Need to cast through any so we can call it a CriteriaField.  :-/
    return relationships[0] as any;
}
